module.exports = __webpack_public_path__ + "media/dashboard/assets/images/inbox_icons/gmail-badge-4808ff2c500e326ea33409655087d8c9.svg";